import Vue from "vue";

const Functions = {
  shortName(longName) {
    if (longName && longName.includes(",")) {
      return longName.split(",")[0]; //+ "," + longName.split(",")[1];
    }
    return longName;
  },
  async getBlobImage(blob) {
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  },
  async getBase64Image(url) {
    const data = await fetch(url, {
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    })
      .then(function(response) {
        return response.blob();
      })
      .then(
        blob =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );
    return data;
  },
  random(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  },
  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  scrollToTop() {
    let $ = window.jQuery;
    $("html, body").animate(
      {
        scrollTop: 0
      },
      600
    );
    //e.preventDefault();
  },
  clearZoomContainer() {
    let $ = window.jQuery;
    $.removeData($("img"), "elevateZoom");
    $(".zoomContainer").remove();
    $(".product-separated-item")
      .find("img")
      .removeData("elevateZoom");
  },
  async getMainImagePath(data) {
    let resp = await Vue.prototype.$http.post(`/api/downloads/image`, {
      FileType: data.FileExtension,
      Path: data.ImagePath
    });

    if (resp && resp.status == 200 && resp.data) {
      return `${Vue.prototype.$apiUrl}/${resp.data}`;
    }
    return `${window.location.origin}/static/images/no-photo.svg`;
  },
  addCommas(nStr) {
    nStr += "";
    var x = nStr.split(",");
    var x1 = x[0];
    var x2 = x.length > 1 ? "," + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  },

  create_UUID() {
    var dt = new Date().getTime();
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
      c
    ) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  },

  isObject(objValue) {
    return (
      objValue &&
      typeof objValue === "object" &&
      objValue.constructor === Object
    );
  },

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  },

  getFileExtension(filename) {
    return /[.]/.exec(filename) ? /[^.]+$/.exec(filename)[0] : null;
  },

  getDomainWithoutSubdomain() {
    let urlParts = location.hostname.includes(".")
      ? location.hostname.split(".")
      : [location.hostname];

    return urlParts
      .slice(0)
      .slice(-(urlParts.length === 4 ? 3 : 2))
      .join(".");
  },

  setCookie(cname, cvalue, days) {
    var dt, expires, domain;
    dt = new Date();
    dt.setTime(dt.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + dt.toGMTString();
    domain = this.getDomainWithoutSubdomain();
    document.cookie = cname + "=" + cvalue + expires + "; domain=" + domain;
  },

  getCookie(cname) {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(";");

    // Loop through the array elements
    for (var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");

      /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
      if (cname == cookiePair[0].trim()) {
        // Decode the cookie value and return
        return decodeURIComponent(cookiePair[1]);
      }
    }

    // Return null if not found
    return null;
  },

  deleteCookie(cname) {
    let domain = this.getDomainWithoutSubdomain();
    if (this.getCookie(cname)) {
      document.cookie =
        cname +
        "=" +
        (domain ? ";domain=" + domain : "") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
  }
};

Functions.install = function(Vue) {
  Vue.prototype.$func = Functions;
};
export default Functions;



// WEBPACK FOOTER //
// ./src/util/functions.js